
import Vue from 'vue';
import ArticleAuthor from '@root/modules/article/components/authors/ArticleAuthor.vue';
import { Author } from '@root/modules/article/types/article';

interface Props {
  authors: Author[];
}

interface Computed {
  showPicture: boolean;
  showAuthorInfo: boolean;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    ArticleAuthor,
  },
  props: {
    authors: {
      type: Array,
      required: true,
    },
  },
  computed: {
    showPicture() {
      return this.authors.length <= 2;
    },
    showAuthorInfo() {
      return this.authors.length < 5;
    },
  },
});
